<div
  style="height: 100vh; width: 100vw; z-index: 999999"
  class="backdrop-blur-md  pt-[72px] pl-4 pr-4 flex flex-col justify-start items-center relative"
>
  <h1
    class="text-[#ff4d06] text-xl md:text-4xl text-center title-font font-medium mb-1"
  >
    Search across all the categories
  </h1>

  <form *ngIf="loaded" class="example-form w-full max-w-96 py-12">
    <div class="w-full">
      <input

        type="text"
        id="search"
        [formControl]="searchCtrl"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#ff4d06] focus:border-[#ff4d06] block w-full p-2.5 dark:bg-black  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white  " autofocus="true"
        placeholder="Search  ex: MSI LAPTOP"
      />
    </div>
    <small class="text-center text-white w-full">{{count}} products</small>
  </form>
  <div *ngIf="!loaded" class="text-white text-xl text-center">
    Please wait, warming up the retro thrusters...
  </div>

  <div
    class="w-full max-w-[600px] py-12 flex flex-col"
    style="overflow: auto; height: 70vh"
    cdkScrollable
  >
    @for (item of searchRes; track $index) {
    <div
      class="flex flex-row gap-4 border-b border-b-slate-400 py-8 hover:bg-[#ff4d0644] pr-4 cursor-pointer relative"
      (click)="close()"
      [routerLink]="['/', item.category?.slug, item.slug + '_' + item.id]"
    >
      <img [src]="item.icon" [alt]="item.label || 'Search result image'" class="w-24 h-24" />

      <div class="flex flex-col">
        <h1 class="text-white title-font !text-[1.2em] font-medium title">
          {{ item.label }}
        </h1>
        <div class="flex flex-col md:flex-row ">
          <div class="flex flex-col gap-1">
            <div class="flex w-full gap-4 justify-between">
              <p class="!text-[1.2em] newP !mb-0">
                {{ item.newPrice | currency : "Rs." : 'Rs.' : '1.0-0'}}
              </p>
            </div>
            <div class="flex">
              <span
                *ngIf="item.discounted"
                class="bg-yellow-300 place-content-center shrink text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full  "
                >Exclusive Deal</span
              >

              <span
                *ngIf="item.newArrival"
                class="bg-yellow-300 place-content-center shrink text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full  "
                >Latest Addition</span
              >
            </div>
            <p class="mt-0 text-gray-400 !text-[1.0em]">
              <span *ngIf="item.discounted" class="line-through">
                ({{ item.previousPrice | currency : "Rs.": 'Rs.' : '1.0-0' }})
              </span>
            </p>

            <div
              class="p-4 cart content-center flex flex-row  "
              (click)="$event.stopPropagation(); handleLike($event,item)"
              style="position: absolute; bottom: 0px; right: 0px"
            >
              <span class="add-to-cart">
                <span class="cart-text">Add to Cart</span>
              </span>
              <img
                src="../../../assets/graphics/add_shopping_cart_FILL0_wght400_GRAD0_opsz24.svg"
                alt="add to shopping cart"
                width="24"
                height="24"
                loading="eager"
              />
              <!-- <mat-icon
              class="text-red-600">add_shopping_cart</mat-icon> -->
            </div>


          </div>
        </div>
      </div>
    </div>
    }
  </div>

  <div class="flex flex-row justify-center  p-4 absolute top-0 right-0" style="z-index: 99999">
    <button
      (click)="close()"
      aria-label="close window"
      class="border border-gray-600 justify-center flex text-white font-semibold py-2 px-4 hover:border-white hover:text-black hover:bg-[#ff4d067c] rounded-lg"
    >
      <span>Close </span>
      &nbsp; &#10006;
      <!-- <img
        src="../../../assets/graphics/close_24dp_FILL1_wght400_GRAD0_opsz24.svg"
      /> -->
    </button>
  </div>
</div>
